import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {Form, FloatingLabel, Row, Col, Button} from 'react-bootstrap';
import {FaFacebook, FaWhatsapp} from 'react-icons/fa';
import axios from 'axios';
import { Telephone } from 'react-bootstrap-icons';
 
class ContactForm extends Component{

  constructor(props) {
    super(props);
    this.state = { name:'', email:'', phone:'', message:'', isValidated: false};
  }

  onChange = (e) => { this.setState({ [e.target.name]:e.target.value }) }

  sendMail = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]:e.target.value, isValidated: true });
    if(this.state.name === "" || this.state.email === "" || this.state.phone === "" || this.state.message === "")
    {
      return;
    }
    const Data = { name: this.state.name, email: this.state.email, phone: this.state.phone, message: this.state.message};
    axios.post("https://fair-solar-leek.glitch.me/send_email", Data)
    .then((res) => {
      console.log(res)
      this.setState({
        name: "",
        email: "",
        phone: "",
        message: "",
        isValidated: false
      })
      alert(res.data === 'Email Sent' ? "אימייל נשלח בהצלחה" : "אימייל לא נשלח");
    })
  }

  resetForm = () => {
    this.setState({
      name: "",
      email: "",
      phone: "",
      message: "",
      isValidated: false
    })
  }

    render(){
    return(
      <div className='container' style={{paddingTop: "55px"}}>
          <header>
          <h2>צרו קשר</h2>
          <h6>מלאו את פרטי הבקשה וניצור איתכם קשר בהקדם</h6>
          </header>
          <div>
        <Form style={{display: 'inline-block'}}>
          <Row xs={1} md={3}>
            <Col>
              <FloatingLabel controlId="name" label="שם מלא" className="mb-3">
                <Form.Control type="text" required placeholder="שם מלא" onChange={this.onChange} value={this.state.name} name="name" isInvalid={this.state.name === "" ? this.state.isValidated ? true : "" : ""} isValid={this.state.name !== "" ? true : ""}/>
                <Form.Control.Feedback type="invalid">שם הוא שדה חובה</Form.Control.Feedback>
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="email" label="אימייל" className="mb-3">
                <Form.Control type="email" required placeholder="name@example.com" onChange={this.onChange} value={this.state.email} name="email" isInvalid={this.state.email === "" ? this.state.isValidated ? true : "" : ""} isValid={this.state.email !== "" ? true : ""}/>
                <Form.Control.Feedback type="invalid">אימייל הוא שדה חובה</Form.Control.Feedback>              
              </FloatingLabel>
            </Col>
            <Col>
              <FloatingLabel controlId="phone" label="נייד" className="mb-3">
                <Form.Control type="text" required placeholder="נייד" onChange={this.onChange} value={this.state.phone} name="phone" isInvalid={this.state.phone === "" ? this.state.isValidated ? true : "" : ""} isValid={this.state.phone !== "" ? true : ""}/>
                <Form.Control.Feedback type="invalid">נייד הוא שדה חובה</Form.Control.Feedback>
              </FloatingLabel>
            </Col>        
          </Row>
          <Row>
            <FloatingLabel controlId="message" label="פירוט הבקשה" className="mb-3">
              <Form.Control as="textarea" required onChange={this.onChange} value={this.state.message} placeholder="תאר את הבקשה כאן" name ="message" style={{height: "200px"}} isInvalid={this.state.message === "" ? this.state.isValidated ? true : "" : ""} isValid={this.state.message !== "" ? true : ""}/>
              <Form.Control.Feedback type="invalid">פירוט הבקשה הוא שדה חובה</Form.Control.Feedback>
            </FloatingLabel>
            <Form.Text className="text-muted">
              <h6>מלא את פרטי הבקשה כאן. אנא התייחס לפעילות המבוקשת ומיקומה.</h6>
            </Form.Text>
          </Row>
            <Button type='submit' onClick={this.sendMail} style={{margin: '15px'}}>שלח טופס</Button>
            <Button type='reset' onClick={this.resetForm} style={{margin: '15px'}}>מחק טופס</Button>
        </Form>
        </div>
        <div>
          <hr></hr>
          <h3>חפשו אותנו גם ב...</h3>
          <a href="https://www.facebook.com/Eligman.Ltd" target="_blank" rel="noreferrer" style={{margin: '15px'}}><FaFacebook color='black'size="50px" /></a>
          <a href="https://wa.me/message/YNZRORK7GIY2P1" target="_blank" rel="noreferrer" style={{margin: '15px'}}><FaWhatsapp color='green' size="50px"/></a>
          <a href="tel:054-5995998" target="_blank" rel="noreferrer" style={{margin: '15px'}}><Telephone color="black" size="50px"/></a>
          <hr></hr>
        </div>
      </div>
    )
  }
}
    
export default ContactForm;